// extracted by mini-css-extract-plugin
export var equalColumn = "_gp-0";